module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei2.svg";